import React from 'react';
import PropTypes from 'prop-types';

const SpaceType = ({ spaceType, bookingsCount }) => {
  return (
    <div>
      {
        (spaceType && bookingsCount) &&
        <div className="use-type-wrapper">
          <i className="ico ico-md icon-verified" style={{ color: '#46bc93' }}></i> { bookingsCount } { spaceType } booked
        </div>
      }
    </div>
  );
};

export default SpaceType;
